module.exports = __webpack_public_path__ + "static/img/avatar_null.67e5727.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar_null.png
// module id = 431
// module chunks = 103